module.exports = __webpack_public_path__ + "img/thumbs_up.cfbd467d.png";